export const chaveDaCategoria = (item) =>
  item?.category_source === "ouran"
    ? `ouran:${item.category_id}`
    : `erp:${item?.legacy_id ?? item?.collection}`;

const todasAsZonas = (zonas) =>
  !Array.isArray(zonas) || zonas.length === 0 || zonas.includes("all");

export const opcoesDaTimeline = (linhas, zonas) => {
  if (!Array.isArray(linhas) || linhas.length === 0) return null;
  const daZona = todasAsZonas(zonas)
    ? linhas
    : linhas.filter((item) => zonas.includes(item.zone));
  const vistas = new Set();
  const opcoes = [{ value: "all", label: "Todos" }];
  daZona.forEach((item) => {
    const chave = chaveDaCategoria(item);
    if (vistas.has(chave)) return;
    vistas.add(chave);
    opcoes.push({ value: chave, label: item.collection || chave });
  });
  return opcoes;
};

export const linhasDasCategorias = (linhas, selecionadas) => {
  if (!Array.isArray(linhas)) return linhas;
  if (
    !Array.isArray(selecionadas) ||
    selecionadas.length === 0 ||
    selecionadas.includes("all")
  ) {
    return linhas;
  }
  const escolhidas = new Set(selecionadas.map(String));
  return linhas.filter((item) => escolhidas.has(chaveDaCategoria(item)));
};
